var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "generation-history" }, [
    _c(
      "button",
      {
        staticClass: "generation-history__trigger",
        class: { "is-open": _vm.isOpen },
        attrs: {
          type: "button",
          "aria-expanded": _vm.isOpen ? "true" : "false",
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.toggle.apply(null, arguments)
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-file-text-o generation-history__trigger-icon",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "generation-history__trigger-label" }, [
          _vm._v(_vm._s(_vm.$t("generation_history.button"))),
        ]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-chevron-down generation-history__trigger-chevron",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
        ref: "panel",
        staticClass: "generation-history__panel fade",
        class: { in: _vm.fadeIn },
        style: _vm.panelStyle,
        attrs: { role: "menu" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", {
          staticClass: "generation-history__panel-arrow",
          style: _vm.arrowStyle,
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "generation-history__columns" }, [
          _c(
            "nav",
            {
              staticClass: "generation-history__nav",
              attrs: { "aria-label": "generation-history-nav" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "generation-history__nav-item",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onOpenAllHistory.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "generation-history__nav-label" }, [
                    _vm._v(_vm._s(_vm.$t("generation_history.history"))),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fa fa-chevron-right generation-history__nav-chevron",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "generation-history__nav-item",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onOpenFavoritesList.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("span", { staticClass: "generation-history__nav-label" }, [
                    _vm._v(_vm._s(_vm.$t("generation_history.favorites_list"))),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fa fa-chevron-right generation-history__nav-chevron",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "generation-history__quick" }, [
            _c("h3", { staticClass: "generation-history__quick-title" }, [
              _vm._v(_vm._s(_vm.$t("generation_history.quick_access"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "generation-history__search" }, [
              _c("div", { staticClass: "generation-history__search-field" }, [
                _c("i", {
                  staticClass: "fa fa-search generation-history__search-icon",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "generation-history__search-input",
                  class: { "has-error": _vm.keywordError },
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t(
                      "generation_history.keyword_placeholder"
                    ),
                  },
                  domProps: { value: _vm.keyword },
                  on: {
                    input: _vm.onKeywordInput,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onKeywordSearch.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.keywordError
                  ? _c(
                      "p",
                      { staticClass: "generation-history__search-error" },
                      [_vm._v(_vm._s(_vm.keywordError))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "generation-history__search-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onKeywordSearch.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("generation_history.search")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "generation-history__shortcuts" }, [
              _c(
                "div",
                {
                  staticClass:
                    "generation-history__shortcuts-row generation-history__shortcuts-row--recent",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "generation-history__shortcut",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onOpenRecentGenerations.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-clock-o",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("generation_history.recent_generations")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generation-history__shortcut",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onOpenRecentFavorites.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon-star",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("generation_history.recent_favorites"))
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "generation-history__shortcuts-row generation-history__shortcuts-row--period",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "generation-history__shortcut",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onOpenToday.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon-calendar" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("generation_history.today"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generation-history__shortcut",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onOpenThisWeek.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon-calendar" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("generation_history.this_week"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generation-history__shortcut",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onOpenThisMonth.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon-calendar" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("generation_history.this_month"))),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "generation-history__nav-icon generation-history__nav-icon--history",
      },
      [
        _c("i", {
          staticClass: "fa fa-clock-o",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "generation-history__nav-icon generation-history__nav-icon--favorites",
      },
      [
        _c("i", {
          staticClass: "icon-star icon-star-o",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }